"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchService = void 0;
class SearchService {
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    /**
     * Search for sponsorships information
     * @param requestBody
     * @returns SearchResultResponse
     * @throws ApiError
     */
    search(requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/search',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Search for sponsorships information
     * @param index
     * @param query
     * @param aggregations
     * @param sort
     * @param from
     * @param size
     * @returns SearchResultResponse
     * @throws ApiError
     */
    searchGet(index, query, aggregations, sort, from, size) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/search',
            query: {
                'index': index,
                'query': query,
                'aggregations': aggregations,
                'sort': sort,
                'from': from,
                'size': size,
            },
        });
    }
    /**
     * Download search for sponsorships information
     * @param requestBody
     * @returns BulkActionResponse
     * @throws ApiError
     */
    searchDownload(requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/search/download',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Returns available search fields information
     * @param index
     * @returns SearchMappingResponse
     * @throws ApiError
     */
    getFields(index) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/search/mapping',
            query: {
                'index': index,
            },
        });
    }
    /**
     * Returns available search terms information
     * @param index
     * @param field
     * @param string
     * @param size
     * @returns SearchTermsResponse
     * @throws ApiError
     */
    getTerms(index, field, string, size) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/search/terms',
            query: {
                'index': index,
                'field': field,
                'string': string,
                'size': size,
            },
        });
    }
}
exports.SearchService = SearchService;
